const VERSION_PATTERN = /^\d+(\.\d+)*$/;

/** Parses a dotted numeric version ("1.0.13"); null when not comparable. */
export function parseVersion(value: string | null | undefined): number[] | null {
  const trimmed = String(value ?? '').trim();
  if (!VERSION_PATTERN.test(trimmed)) return null;
  return trimmed.split('.').map(Number);
}

/**
 * Compares dotted numeric versions segment by segment; missing segments
 * count as 0, so "1.0" equals "1.0.0". Returns null if either is invalid.
 */
export function compareVersions(
  left: string | null | undefined,
  right: string | null | undefined,
): number | null {
  const a = parseVersion(left);
  const b = parseVersion(right);
  if (!a || !b) return null;
  const length = Math.max(a.length, b.length);
  for (let index = 0; index < length; index += 1) {
    const difference = (a[index] ?? 0) - (b[index] ?? 0);
    if (difference !== 0) return difference < 0 ? -1 : 1;
  }
  return 0;
}

export function isVersionBelow(
  installed: string | null | undefined,
  minimum: string | null | undefined,
): boolean {
  const result = compareVersions(installed, minimum);
  return result !== null && result < 0;
}
